import { c as O, a as U, g as _ } from "../helpers-BfS4Sl3r.mjs";
import { a as D, g as q } from "../language-BmpVHS7x.mjs";
function w(e) {
  const r = [];
  for (let t = 0; t < (e == null ? void 0 : e.length); t++) {
    const n = e == null ? void 0 : e[t];
    n && r.push({ ...n });
  }
  return r;
}
function T(e, r, t) {
  if (e === void 0)
    return "";
  const o = e.toFixed(2).split("."), s = o[0], i = o[1];
  if (!s || !i)
    return e.toString();
  const c = parseInt(s).toLocaleString(r);
  return i === "00" ? `${c} ${t}` : `${c},${i} ${t}`;
}
function S(e) {
  return e === "" || e === void 0 || e === null;
}
function $(e) {
  let r = !1;
  return {
    promise: new Promise((o, s) => {
      e.then(
        (i) => !r && o(i),
        (i) => !r && s(i)
      );
    }),
    cancel: () => {
      r = !0;
    }
  };
}
const d = new RegExp(
  /^(?<vehicleTypeCode>\w{3})(?<engineCode>\w{2})(?<salesVersionCode>\w{2})(?<yearEditionCode>\w{1})(?<transmissionCode>\w{1})(?<steeringWheelCode>\w{1})(?<marketCode>\w{2})(?<sixDigitsCode>\d{6})$/g
);
function x(e) {
  if (e.length !== 18)
    return;
  const r = d.exec(e);
  if (r != null && r.groups)
    return r.groups;
}
const p = {
  legalWLTP: ["consumption_wltp_combined", "powerconsumptioncombined"],
  legalEmissions: "co2emissioncombined",
  legalRange: "range_wltp_combined",
  legalRangeCity: "range_wltp_city"
}, g = {
  legalNEDC: "---"
}, m = (e) => p[e], f = (e, r) => {
  const t = e.includes(r);
  if (!t) {
    const n = m(r);
    if (!n)
      return !1;
    const o = Array.isArray(n) && n.some((i) => e.includes(i)), s = typeof n == "string" && e.includes(n);
    return o || s;
  }
  return t;
}, y = (e, r) => {
  const t = r == null ? void 0 : r.find(
    (n) => f(n.code, e)
  );
  return t != null && t.value ? t == null ? void 0 : t.value : g[e] || `{{${e}}}`;
}, b = (e, r) => e.replace(
  /{{\w+}}/g,
  function(n) {
    const o = n.substring(
      2,
      n.length - 2
    );
    return y(o, r);
  }
), P = (e) => e ? e.reduce((r, t) => {
  let n = -1;
  const o = r.find((s, i) => (n = i, s.priority === t.priority));
  return o && n > -1 ? (r[n] = {
    ...o,
    description: `${o.description}<br/>${t.description}`
  }, r) : (r.push(t), r);
}, []) : [], L = (e, r = 3) => P(e).slice(0, r);
function E(e, r, t) {
  const n = e.find((o) => o[r] === t);
  return n || null;
}
const I = (e) => {
  switch (e == null ? void 0 : e.substring(0, 2)) {
    case "HX":
      return "smart #1";
    case "HC":
      return "smart #3";
    default:
      return;
  }
}, l = "{{product}}", a = "{{model}}", u = "{{featureApp}}", C = `smart/smart-dam/digital/products/cars/${a}/specific/${l}/${u}/`, M = (e, r, t) => C.replace(l, r).replace(a, t).replace(u, e), R = (e) => {
  const r = e.toUpperCase();
  if (r.includes("MRS") || r.includes("MISS") || r.includes("MS"))
    return 1;
  if (r.includes("MR"))
    return 0;
};
function A(e, r) {
  return e[r] ?? e.DEFAULT;
}
function B({
  value: e,
  record: r
}) {
  return e ? Object.values(r).some(
    (t) => t.toString().toUpperCase() === e.toString().toUpperCase()
  ) : !1;
}
function F(e, r) {
  return r.reduce((n, o) => (n[o] = e[o], n), {});
}
const H = (e, r) => (e == null ? void 0 : e[r]) || (e == null ? void 0 : e.umweltbonus);
export {
  O as convertArrayToMapByKey,
  U as convertArrayToObjectOfArraysByKey,
  w as copyNonNullItems,
  T as formatPrice,
  D as getCountryCode,
  H as getFootnotes,
  L as getHighlightEquipments,
  M as getImageUrlForProduct,
  E as getItemByKeyAndValue,
  q as getLanguage,
  I as getModelFromPn18,
  _ as getObjectKeys,
  A as getPropertyValueOrDefault,
  R as getTitleCode,
  y as getValue,
  B as includesValueInRecord,
  S as isNullish,
  $ as makeCancelable,
  F as mapObjectKeys,
  x as parsePn18,
  b as replaceDisclaimerTagsWithValue
};
//# sourceMappingURL=index.mjs.map
